/* VideoLinks: snappier Add to Cart.
   Opens the cart drawer the moment a product form is submitted (with an "adding" state),
   instead of waiting for Shopify's reply. The theme's own add-to-cart code is unchanged:
   it still sends the request and renders the drawer contents when the reply arrives.
   If the add fails (out of stock, limits, network), the drawer closes and the theme's
   normal error message shows, exactly as before. */
(function () {
  'use strict';
  if (window.__vlCartSnappy) return;
  window.__vlCartSnappy = true;

  var cycle = null; // { drawer, form, succeeded, timers[] }

  function settings() { return window.MinimogSettings || {}; }
  function getDrawer() { return document.querySelector('m-cart-drawer'); }

  function injectStyles() {
    if (document.getElementById('vl-cart-snappy-styles')) return;
    var s = document.createElement('style');
    s.id = 'vl-cart-snappy-styles';
    s.textContent = [
      'm-cart-drawer.vl-cart-adding [data-minimog-cart-items]{opacity:.45;pointer-events:none;transition:opacity .15s}',
      'm-cart-drawer.vl-cart-adding .m-cart-drawer__inner{overflow:hidden}',
      'm-cart-drawer.vl-cart-adding .m-cart-drawer__inner::before{content:"";position:absolute;z-index:5;top:0;left:0;height:3px;width:35%;background:#054CB4;border-radius:0 3px 3px 0;animation:vl-cart-bar 1s ease-in-out infinite}',
      '@keyframes vl-cart-bar{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}',
      'm-cart-drawer.vl-cart-adding .m-cart-drawer__empty{display:none!important}',
      'm-cart-drawer.vl-cart-adding.m-cart--empty [data-minimog-cart-items]::before{content:"Adding to your cart\\2026";display:block;padding:24px 0;text-align:center;font-size:14px;opacity:1}',
      '@media (prefers-reduced-motion:reduce){m-cart-drawer.vl-cart-adding .m-cart-drawer__inner::before{animation:none;width:100%;opacity:.6}}'
    ].join('');
    document.head.appendChild(s);
  }

  function clearCycle() {
    if (!cycle) return;
    cycle.timers.forEach(clearTimeout);
    if (cycle.observer) cycle.observer.disconnect();
    cycle.drawer.classList.remove('vl-cart-adding');
    cycle = null;
  }

  function finish() { clearCycle(); }

  function fail() {
    if (!cycle) return;
    var d = cycle.drawer, wasOpenedByUs = cycle.openedByUs;
    clearCycle();
    if (wasOpenedByUs && typeof d.close === 'function') d.close();
  }

  // Watch Shopify's reply to the add request to know success vs failure.
  function patchFetch() {
    if (window.__vlCartSnappyFetch) return;
    window.__vlCartSnappyFetch = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = String((input && input.url) || input || ''); } catch (e) {}
      var p = orig.apply(this, arguments);
      if (cycle && !cycle.requestSeen && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        cycle.requestSeen = true;
        var c = cycle;
        p.then(function (res) {
          if (cycle !== c) return;
          if (!res.ok) { fail(); return; }
          return res.clone().json().then(function (j) {
            if (cycle !== c) return;
            if (j && j.status && j.status >= 400) { fail(); return; }
            c.succeeded = true;
            // contents arrive via the theme's render; finish when the items area changes, or after a safety delay
            if (c.rendered) { finish(); return; }
            c.timers.push(setTimeout(function () { if (cycle === c) finish(); }, 6000));
          }).catch(function () { /* unparseable but ok response: let the theme handle it */ c.succeeded = true; c.timers.push(setTimeout(function () { if (cycle === c) finish(); }, 6000)); });
        }, function () { if (cycle === c) fail(); });
      }
      return p;
    };
  }

  function watchItems(drawer) {
    var items = drawer.querySelector('[data-minimog-cart-items]');
    if (!items || !cycle) return;
    var c = cycle;
    c.observer = new MutationObserver(function () {
      c.rendered = true;
      if (cycle === c && c.succeeded) setTimeout(function () { if (cycle === c) finish(); }, 50);
    });
    c.observer.observe(items, { childList: true, subtree: true });
  }

  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var pf = form.closest('product-form');
    if (!pf) return;
    var s = settings();
    if (!s.use_ajax_atc || !s.enable_cart_drawer) return;
    var drawer = getDrawer();
    if (!drawer || typeof drawer.open !== 'function') return;

    // Start the cycle now (capture phase, before the theme's handler sends the request) so the
    // reply is always observed. The drawer itself is opened right after the theme's handler runs.
    if (cycle) clearCycle();
    var c = cycle = { drawer: drawer, form: form, succeeded: false, requestSeen: false, openedByUs: false, timers: [] };

    setTimeout(function () {
      if (cycle !== c) return;
      if (!c.requestSeen && !pf.classList.contains('m-spinner-loading')) { clearCycle(); return; } // validation failed: theme shows its message
      c.timers.push(setTimeout(function () { if (cycle === c) fail(); }, 20000)); // never leave the drawer stuck
      drawer.classList.add('vl-cart-adding');
      if (!drawer.classList.contains('m-cart-drawer--active')) {
        drawer.open();
        c.openedByUs = true;
      }
      watchItems(drawer);
      if (c.succeeded && c.rendered) finish();
    }, 0);
  }

  // When the theme opens the drawer again after rendering, skip re-opening an already-open drawer.
  function patchOpen() {
    var C = customElements.get('m-cart-drawer');
    if (!C || C.prototype.__vlOpenPatched) return;
    var op = C.prototype.open;
    C.prototype.open = function () {
      if (this.classList.contains('m-cart-drawer--active') && this.classList.contains('vl-cart-adding')) return;
      return op.apply(this, arguments);
    };
    C.prototype.__vlOpenPatched = true;
  }

  function init() {
    try {
      injectStyles();
      patchFetch();
      if (customElements.get('m-cart-drawer')) patchOpen();
      else customElements.whenDefined('m-cart-drawer').then(patchOpen);
      document.addEventListener('submit', onSubmit, true);
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
